import { GetStaticProps } from "next";

import { RegionIndexPage } from "@/containers/RegionIndexContainer/RegionIndexPage";
import { buildRegionIndexPageProps } from "@/utils/buildRegionIndexProps";

export const getStaticProps: GetStaticProps = async () => ({
  props: buildRegionIndexPageProps("charnel"),
});

export default RegionIndexPage;
